 <template>
 <div class="user">
 <h1> {{ msg }} </h1>
 <div v-if="showFormDialog">
 <h3>{{ formId > 0 ? '编辑账号' : '新增账号' }}</h3>
 <form accept-charset="UTF-8">
 <label for="fname">名称</label><input type="text" v-model="form.name" id="fname" /><br/>
 <label for="fcategory">分类</label><select v-model="form.category" id="fcategory" @change="categoryFormChanged">
 <option value="llm">大语言模型</option>
 <option value="ocr">OCR识别</option>
 </select><br/>
 <label for="fprovider">提供商</label><select v-model="form.provider" id="fprovider" @change="providerChanged">
 <option value="glm">glm</option>
 <option value="deepseek" v-if="form.category !== 'ocr'">deepseek</option>
 <option value="openai">openai</option>
 <option value="custom">custom</option>
 </select><br/>
 <label for="fbase_url">Base URL</label><input type="text" v-model="form.base_url" id="fbase_url" :readonly="form.provider !== 'custom'" :placeholder="form.provider === 'custom' ? '请输入接口地址' : ''" /><br/>
 <label for="fmodel">模型</label><input type="text" v-model="form.model" id="fmodel" :placeholder="modelPlaceholder" /><br/>
 <label for="fapi_key">API Key</label><input type="password" v-model="form.api_key" id="fapi_key" :placeholder="formId > 0 ? '留空则不修改' : ''" /><br/>
 <label for="fremark">备注</label><input type="text" v-model="form.remark" id="fremark" /><br/>
 <label for="fenabled">状态</label><select v-model="form.enabled" id="fenabled">
 <option :value="true">启用</option>
 <option :value="false">禁用</option>
 </select><br/>
 <button @click="formSubmit" type="button">提交</button>
 <button @click="formCancel" type="button">取消</button>
 </form>
 </div>
 <div v-else="showFormDialog">
 <div>
 <form accept-charset="UTF-8">
 <label for="words">搜索词</label><input type="text" v-model="words" id="words" /><br/>
 <label for="category">分类</label><select v-model="category" id="category" @change="categoryChanged">
 <option value="">全部</option>
 <option value="llm">大语言模型</option>
 <option value="ocr">OCR识别</option>
 </select><br/>
 <button @click="searchNow" type="button">搜索</button>
 <button @click="searchClean" type="button">清空</button>
 <button @click="accountAdd" type="button">新增账号</button>
 </form>
 </div>
 <div>
 目前匹配到账号： {{ total }} 个。
 </div>
 <div id="aiaccount">
 <table>
 <thead>
 <tr>
 <th> ID </th>
 <th> 名称 </th>
 <th> 分类 </th>
 <th> 提供商 </th>
 <th> Base URL </th>
 <th> 模型 </th>
 <th> API Key </th>
 <th> 状态 </th>
 <th> 备注 </th>
 <th> 操作 </th>
 </tr>
 </thead>
 <tbody>
 <tr v-for="(item, index) in accounts" :key = "item.id">
 <td><h5>{{ item.id }}</h5></td>
 <td>{{ item.name }}</td>
 <td>{{ item.category | categoryStr }}</td>
 <td>{{ item.provider }}</td>
 <td>{{ item.base_url }}</td>
 <td>{{ item.model }}</td>
 <td>{{ item.api_key_masked }}</td>
 <td>{{ item.enabled ? '启用' : '禁用' }}</td>
 <td>{{ item.remark }}</td>
 <td>
 <button @click="accountEdit(index)">编辑</button>
 <button @click="accountToggle(index)">{{ item.enabled ? '禁用' : '启用' }}</button>
 <button @click="accountDelete(index)">删除</button>
 </td>
 </tr>
 </tbody>
 </table>
 </div>

 <a v-if="moreBtn" href="javascript:void(0);" v-on:click="loadMore">加载更多</a>
 <span v-else="moreBtn">全部加载完毕</span>
 </div>
 </div>
 </template>

 <script>
 import axios from "axios"
 export default {
 name: 'AiAccount',
 data() {
 return {
 msg: 'AI账号管理',
 total: 0,
 moreBtn: false,
 isLogin: false,
 words: '',
 category: '', // 分类筛选
 lastId: 0,
 accounts: [],
 showFormDialog: false,
 formId: 0, // 0表示新增，大于0表示编辑
 // 内置提供商的官方接口地址（OpenAI v1 兼容），选择后自动填入且只读
 providerUrls: {
 glm: 'https://open.bigmodel.cn/api/paas/v4',
 deepseek: 'https://api.deepseek.com/v1',
 openai: 'https://api.openai.com/v1',
 },
 // 各提供商的模型填写提示
 modelPlaceholders: {
 glm: '如 glm-4v-flash',
 deepseek: '如 deepseek-chat',
 openai: '如 gpt-4o',
 custom: '模型名称',
 },
 form: {
 name: '',
 category: 'llm',
 provider: 'glm',
 base_url: 'https://open.bigmodel.cn/api/paas/v4',
 api_key: '',
 model: '',
 remark: '',
 enabled: true,
 },
 }
 }, // data()
 computed: {
 modelPlaceholder() {
 return this.modelPlaceholders[this.form.provider] || '模型名称';
 },
 }, // computed
 mounted() {
 if (sessionStorage.getItem("account") && sessionStorage.getItem("token")) {
 this.isLogin = true;
 this.uid = sessionStorage.getItem("uid")
 this.token = sessionStorage.getItem("token")
 this.nickname = sessionStorage.getItem("nickname")
 try {
 this.amount = parseInt(sessionStorage.getItem("amount"));
 } catch (e) {}
 this.typ = sessionStorage.getItem("typ");
 // 最后去抓取数据
 this.loadAccountsData()
 } else {
 alert("请先登录")
 this.$router.push({name: "Login"})
 }
 }, // mounted
 methods: {
 // 分类切换时，OCR 不支持 deepseek（官方API无图像能力），自动回退到 glm
 categoryFormChanged() {
 if (this.form.category === 'ocr' && this.form.provider === 'deepseek') {
 this.form.provider = 'glm'
 this.providerChanged()
 }
 }, // categoryFormChanged
 // 提供商切换时，内置平台自动填入官方地址并只读，只有 custom 可编辑
 providerChanged() {
 if (this.form.provider !== 'custom') {
 this.form.base_url = this.providerUrls[this.form.provider] || ''
 }
 }, // providerChanged
 loadAccountsData() {
							const query = {
 uid: this.uid,
 access_token: this.token,
 lastId: this.lastId,
 search: this.words,
 category: this.category,
 time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 query.search = encodeURIComponent(query.search)
 const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/ai/accounts?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
 if (response.data.code == 0) {
 this.total = response.data.data.total
 for (const it of response.data.data.items) {
 this.accounts.push(it);
 this.lastId = it.id;
 } // for
 this.moreBtn = this.accounts.length <this.total
 } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
 }, // loadAccountsData
 loadMore() {
 this.loadAccountsData();
 }, // loadMore
 searchNow() {
 this.lastId = 0
 this.accounts = [];
 this.loadAccountsData()
 }, // searchNow
 searchClean() {
 if (this.words == '') {
 return;
 }
 this.lastId = 0
 this.words = '';
 this.accounts = [];
 this.loadAccountsData()
 }, // searchClean
 categoryChanged() {
 this.lastId = 0
 this.accounts = []
 this.loadAccountsData()
 }, // categoryChanged
 accountAdd() {
 this.formId = 0
 this.form = {
 name: '',
 category: 'llm',
 provider: 'glm',
 base_url: this.providerUrls.glm,
 api_key: '',
 model: '',
 remark: '',
 enabled: true,
 }
 this.showFormDialog = true
 }, // accountAdd
 accountEdit(index) {
 const account = this.accounts[index]
 if (!account) {
 return;
 }
 this.formId = account.id
 this.form = {
 name: account.name,
 category: account.category,
 provider: account.provider,
 base_url: account.provider !== 'custom' ? (this.providerUrls[account.provider] || account.base_url) : account.base_url,
 api_key: '', // 编辑时留空表示不修改
 model: account.model,
 remark: account.remark || '',
 enabled: account.enabled,
 }
 this.showFormDialog = true
 }, // accountEdit
 formCancel() {
 this.showFormDialog = false
 }, // formCancel
 formSubmit() {
 if (this.form.name == '') {
 alert("名称不能为空。");
 return;
 }
 if (this.form.category == '') {
 alert("分类不能为空。");
 return;
 }
 if (this.form.base_url == '') {
 alert("Base URL不能为空。");
 return;
 }
 if (this.formId == 0 && this.form.api_key == '') {
 alert("新增账号时API Key不能为空。");
 return;
 }
 const time = (new Date().getTime() / 1000);
 const formData = {
 uid: this.uid,
 access_token: this.token,
 time: time,
 name: this.form.name,
 category: this.form.category,
 provider: this.form.provider,
 base_url: this.form.base_url,
 api_key: this.form.api_key,
 model: this.form.model || '',
 remark: this.form.remark || '',
 enabled: this.form.enabled,
 }
 const sig = this.checkSig(formData)
 // 删掉重复的内容
 delete formData.uid
 delete formData.access_token
 delete formData.time
 const url = this.formId > 0
 ? `${this.WEBCONF.url}admin/ai/accounts/${this.formId}/update`
 : `${this.WEBCONF.url}admin/ai/accounts/add`
 axios.post(`${url}?uid=${this.uid}&access_token=${this.token}&time=${time}&sig=${sig}`, formData, {
 'Content-Type': 'application/json'
 })
    .then(response => {
        if(response.status==200) {
                    if(response.data.code==0) {
                    alert(this.formId > 0 ? '编辑成功。' : '新增成功。');
                    this.showFormDialog = false
                    // 重新加载数据
                    this.lastId = 0
                    this.accounts = [];
                    this.loadAccountsData()
                                                } else {
            alert(response.data.reason);
    }
    }
    }).catch(err => {
    alert("网络错误。");
    })
 }, // formSubmit
 accountToggle(index) {
 const account = this.accounts[index]
 if (!account) {
 return;
 }
 const time = (new Date().getTime() / 1000);
 const formData = {
 uid: this.uid,
 access_token: this.token,
 time: time,
 name: account.name,
 category: account.category,
 provider: account.provider,
 base_url: account.base_url,
 api_key: '', // 留空表示不修改
 model: account.model || '',
 remark: account.remark || '',
 enabled: !account.enabled,
 }
 const sig = this.checkSig(formData)
 // 删掉重复的内容
 delete formData.uid
 delete formData.access_token
 delete formData.time
 axios.post(`${this.WEBCONF.url}admin/ai/accounts/${account.id}/update?uid=${this.uid}&access_token=${this.token}&time=${time}&sig=${sig}`, formData, {
 'Content-Type': 'application/json'
 })
    .then(response => {
        if(response.status==200) {
                    if(response.data.code==0) {
                    account.enabled = !account.enabled;
                    alert(account.enabled ? '已启用。' : '已禁用。');
                                                } else {
            alert(response.data.reason);
    }
    }
    }).catch(err => {
    alert("网络错误。");
    })
 }, // accountToggle
 accountDelete(index) {
 const account = this.accounts[index]
 if (!account) {
 return;
 }
						if(!confirm(`确认要删除： ${account.name}，删除后无法恢复。`)) {
							return;
						}
						const query = {
 uid: this.uid,
 access_token: this.token,
 time: (new Date().getTime() / 1000),
 };
 query.sig = this.checkSig(query)
 const params = [];
 for (const key in query) {
 params.push(`${key}=${query[key]}`);
 }
 axios.get(`${this.WEBCONF.url}admin/ai/accounts/${account.id}/destroy?${params.join('&')}`)
 .then(response => {
 if (response.status == 200) {
 if (response.data.code == 0) {
 this.accounts.splice(index,1)
 alert(`成功删除账号${account.name}`);
  } else {
 alert(response.data.reason);
 }
 }
 }).catch(err => {
 alert("网络错误。");
 })
						}, // accountDelete
 }, // methods
 filters: {
 categoryStr(category) {
 switch(category) {
 case 'llm':
 return '大语言模型'
 case 'ocr':
 return 'OCR识别'
 default:
 return category
 } // switch
 }, // categoryStr
 }, // filters
 }
 </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/AiAccount.vue